var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.745575,
    y: 0.212158,
    width: 39.5632,
    height: 40.3431,
    rx: 19.7816,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.7809,
    height: 20.5608,
    transform: "translate(10.6367 10.1033)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2966 21.2403V25.5238C26.2966 25.995 25.9257 26.3805 25.4724 26.3805H15.5819C15.1286 26.3805 14.7577 25.995 14.7577 25.5238V21.2403C14.7577 20.7692 14.3868 20.3836 13.9335 20.3836C13.4802 20.3836 13.1093 20.7692 13.1093 21.2403V26.3805C13.1093 27.3229 13.8511 28.0939 14.7577 28.0939H26.2966C27.2032 28.0939 27.945 27.3229 27.945 26.3805V21.2403C27.945 20.7692 27.5741 20.3836 27.1208 20.3836C26.6675 20.3836 26.2966 20.7692 26.2966 21.2403ZM21.3514 20.9576L22.9009 19.347C23.2223 19.0129 23.7416 19.0129 24.063 19.347C24.3845 19.6811 24.3845 20.2209 24.063 20.555L21.1041 23.6305C20.7827 23.9646 20.2634 23.9646 19.942 23.6305L16.9831 20.555C16.6617 20.2209 16.6617 19.6811 16.9831 19.347C17.3045 19.0129 17.8238 19.0129 18.1452 19.347L19.703 20.9576V13.53C19.703 13.0589 20.0739 12.6733 20.5272 12.6733C20.9805 12.6733 21.3514 13.0589 21.3514 13.53V20.9576Z",
    fill: "#4779A4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.1b1fb122.svg";
export { ForwardRef as ReactComponent };